<template>
  <BaseBadge
      :class="{
        'bg-red' : status === 0,
        'bg-yellow' : status === 1,
        'bg-green' : status === 2,
        'bg-text-ternary' : status === 3
      }">
    {{ ticketStatus.name }}
  </BaseBadge>
</template>

<script>
import {mapGetters} from "vuex";
import BaseBadge from "@/components/UI/BaseBadge";

export default {
  name: "TicketStatusBadge",
  components: {BaseBadge},
  props: {
    status: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('cabinet/constants', ['getConstantList']),
    ticketStatusList() {
      return this.getConstantList('ticket_status')
    },
    ticketStatus() {
      return this.ticketStatusList.find(status => +status.id === this.status)
    }
  }
}
</script>